module.exports = __webpack_public_path__ + "img/ticket.ebfbb848.svg";